module.exports = __webpack_public_path__ + "img/point.19905509.png";